export default {
  path: "/medidas",
  name: "Medidas",
  component: () => import("../pages/index.vue")
};
